<template>
  <div>
    <v-row dense>
      <v-col class="px-2" cols="6">
        <v-autocomplete
          :disabled="isCustomUser"
          :items="userList"
          :rules="[v => isCustomUser === true || v != null || $t('global.error.required')]"
          :label="$t('travelService.orderUserSelect.person')"
          ref="userSelect"
          v-model="contextUser"
        />
      </v-col>
      <v-col class="px-2" cols="6">
        <v-checkbox :label="$t('travelService.orderUserSelect.differentPerson')" v-model="isCustomUser" />
      </v-col>
    </v-row>

    <v-row v-if="isCustomUser" dense>
      <v-col class="px-2">
        <v-text-field :rules="[isRequired]" :label="$t('user.name') + '*'" v-model="contextModel.name" />
      </v-col>
      <v-col class="px-2">
        <v-text-field :rules="[isRequired]" :label="$t('user.surname') + '*'" v-model="contextModel.surname" />
      </v-col>
    </v-row>
    <v-row v-if="birthDateRequired" dense>
      <v-col class="px-2" cols="6">
        <date-picker :rules="[isRequired]" :label="$t('user.birthDate') + '*'" :model.sync="contextModel.birth_date" />
      </v-col>
      <v-col class="py-5">
        <v-tooltip bottom v-if="contextModel.company_user_id && $store.getters.hasPermission('saveUserDataFromTravelService')">
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" @click="saveInUserProfile()" class="my-0 py-0" :disabled="!isUserDataDifferentFromUserProfile()">
              <v-icon>fa-cloud-upload-alt</v-icon>
            </v-btn>
          </template>
          {{ $t("global.saveInUserProfile") }}
        </v-tooltip>
        <v-tooltip bottom v-if="contextModel.company_user_id">
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" class="my-0 py-0" :disabled="!isUserDataDifferentFromUserProfile()" @click="writeSelectedUserData(contextUser)">
              <v-icon>fa-cloud-download-alt</v-icon>
            </v-btn>
          </template>
          {{ $t("components.travelUserInlineForm.loadFromUserProfile") }}
        </v-tooltip>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import UserModelClass from "../../models/travelOrder/userModel";
import DatePicker from "../CustomInputComponents/DatePicker";

export default {
  name: "OrderUserSelect",
  components: { DatePicker },
  props: {
    value: {
      required: true
    },
    birthDateRequired: {
      default: false,
      required: false
    }
  },
  data: () => ({
    customUser: false,
    userId: null
  }),
  created() {
    if (this.value != null && typeof this.value.company_user_id !== "undefined" && this.value.company_user_id === null && this.value.name != null) {
      this.customUser = true;
    }
  },
  watch: {
    value: {
      handler(val) {
        if (val != null && typeof val.company_user_id !== "undefined" && val.company_user_id === null && val.name != null) {
          this.customUser = true;
        }
      },
      deep: true
    }
  },
  computed: {
    availableUsers() {
      return this.$store.state.TravelService.availableUsers;
    },
    contextModel: {
      get() {
        if (this.value == null) {
          this.$emit("update:value", new UserModelClass());
        }
        return this.value;
      },
      set(value) {
        this.$emit("update:value", value);
      }
    },
    userList() {
      let result = [];
      for (let user of this.availableUsers) {
        result.push({ text: user.surname + " " + user.name, value: user.id });
      }
      return result;
    },
    contextUser: {
      get() {
        return this.contextModel == null ? null : this.contextModel.company_user_id;
      },
      set(value) {
        this.writeSelectedUserData(value);
      }
    },
    isCustomUser: {
      get() {
        return this.customUser;
      },
      set(value) {
        this.customUser = value;
        this.user = null;
        this.contextModel.company_user_id = null;
        this.$refs.userSelect.validate();
      }
    }
  },
  methods: {
    isUserDataDifferentFromUserProfile() {
      if (this.contextUser === null) {
        return false;
      }
      let selectedUser = this.availableUsers.find(v => v.id === this.contextUser);
      return this.contextModel.birth_date !== selectedUser.birth_date;
    },
    saveInUserProfile() {
      this.$store
        .dispatch("confirmDialog", {
          content: this.$t("components.travelUserInlineForm.saveDialog.content"),
          title: this.$t("components.travelUserInlineForm.saveDialog.title")
        })
        .then(() => {
          this.axios.post("travel-service/save-user-data-in-user-profile", this.contextModel).then(() => {
            this.$store.dispatch("snackbarPush", {
              text: this.$t("global.saved"),
              position: "down"
            });
            this.$store.dispatch("TravelService/downloadAvailableUsers");
            this.$emit("saved");
          });
        })
        .catch();
    },
    writeSelectedUserData(value) {
      if (value != null) {
        let selectedUser = this.availableUsers.find(v => v.id === value);
        this.contextModel.company_user_id = selectedUser.id;
        this.contextModel.name = selectedUser.name;
        this.contextModel.surname = selectedUser.surname;
        this.contextModel.email = selectedUser.email;
        this.contextModel.birth_date = selectedUser.birth_date;
        this.contextModel.document_number = selectedUser.document_number;
        this.contextModel.phone = selectedUser.phone;
        this.contextModel.defaultCostCentre = selectedUser.defaultCostCentre;
        this.contextModel.costCentres = selectedUser.costCentres;
      }
    },
    isRequired(v) {
      return (v != null && v.length > 0) || this.$t("global.error.required");
    }
  },
  mounted() {
    // console.log(this.$route);
    // console.log(this.$store.state.DelegationOrder.delegationOrderEdited.user_id);
    // if (this.$route.fullPath.includes("delegation-order") && this.$store.state.DelegationOrder.delegationOrderEdited.user_id !== null) {
    //   this.writeSelectedUserData(this.$store.state.DelegationOrder.delegationOrderEdited.user_id);
    // }
  }
};
</script>

<style scoped></style>
